import { render, staticRenderFns } from "./AdjustStock.vue?vue&type=template&id=6a2b60ce&scoped=true&"
import script from "./AdjustStock.vue?vue&type=script&lang=js&"
export * from "./AdjustStock.vue?vue&type=script&lang=js&"
import style0 from "./AdjustStock.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AdjustStock.vue?vue&type=style&index=1&id=6a2b60ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2b60ce",
  null
  
)

export default component.exports